import React, {useState} from 'react';
import {toast} from "react-toastify";
import classnames from "classnames";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import DeleteSharpIcon from "@mui/icons-material/DeleteSharp";
import {useUserContext} from "../../../contexts/UserContext";
import useDidMountEffect from "../../../hooks/useDidMountEffect";

import {useDealCRMContext} from "../../../contexts/DealCRMPageContext";
import Checkbox from "@mui/material/Checkbox";
import {useDebounce} from "@uidotdev/usehooks";
import {CRMListDealsModal} from "../../CRM/CRMListDealsPage/CRMListDealsModal";
import {CustomCRMItemRowEntry} from "../../CRM/CustomCRMItemRowEntry";
import {useModalsStore} from "../../../stores/modalsStore";
import {useShallow} from "zustand/react/shallow";


const getInitialState = (lead) => ({...lead})

export const DealPageCRMLeadItem = ( { lead } ) => {
    const { profileState } = useUserContext()
    const { updateLead, deleteLead, selectedLeads, setSelectedLeads, updateLeadResponse } = useDealCRMContext()
    const [leadState, setLeadState] = useState(getInitialState(lead))
    const debouncedLeadState = useDebounce(leadState, 300)

    const {
        openModal,
        findModalById,
        updateModalById,
    } = useModalsStore(
        useShallow((state) => ({
            openModal: state.openModal,
            findModalById: state.findModalById,
            updateModalById: state.updateModalById,
        }))
    )

    const [isFocused, setIsFocused] = useState(false);
    const [isEmailFocused, setIsEmailFocused] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOnFocus = () => {
        setIsFocused(true);
    }

    const handleBlur = () => {
        setIsFocused(false);
    }

    const handleEmailFocus = () => {
        setIsEmailFocused(true);
    }

    const handleEmailBlur = () => {
        setIsEmailFocused(false);
    }

    const handleActionClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setAnchorEl(null);
    };

    const setStateWithUpdate = (newState) => {
        setLeadState({...newState, _should_update: true})
    }

    const setStateWithoutUpdate = (newState) => {
        setLeadState({...newState, _should_update: false})
    }

    const updateLeadItem = () => {
        return updateLead(lead.id, leadState).then((data) => {
        })
    }

    const deleteLeadItem = () => {
        return deleteLead(lead.id).then((data) => {
            toast.success("Successfully deleted lead.")
        })
    }

    const toggleSelected = () => {
        let newList = structuredClone(selectedLeads)
        if (selectedLeads.includes(lead.id)) {
            newList = newList.filter(id => id !== lead.id)
        } else {
            newList = [...newList, lead.id]
        }
        setSelectedLeads([...newList])
    }

    const setLeadQuotes = (toggledDealId) => {
        let newDealIds = structuredClone(leadState.deals)
        if (newDealIds.includes(toggledDealId)) {
            newDealIds = newDealIds.filter((dealId) => dealId !== toggledDealId)
        } else {
            newDealIds = [...newDealIds, toggledDealId]
        }

        const newState = {...leadState, deals: newDealIds}
        return updateLead(lead.id, newState).then((data) => {
            const newReturnedDeals = data?.data?.deals
            setStateWithoutUpdate({...leadState, deals: newReturnedDeals})
            return newReturnedDeals
        })
    }

    useDidMountEffect(function updateLeadItemAfterDebounce(){
        if (debouncedLeadState._should_update === true && !isEmailFocused) {
            updateLeadItem()
        }
    }, [debouncedLeadState, isEmailFocused])

    useDidMountEffect(function setLeadItemStateOnUpdateResponse(){
        if (updateLeadResponse?.data?.data && !updateLeadResponse.loading && !updateLeadResponse.error) {
            const newLeadData = updateLeadResponse?.data?.data
            if (newLeadData.id === lead.id) {
                const newDeals = newLeadData.deals
                setStateWithoutUpdate({...leadState, deals: newDeals})

                if (findModalById("CRMListDealsModal")) {
                    updateModalById("CRMListDealsModal", {
                        element: CRMListDealsModal,
                        id: "CRMListDealsModal",
                        props: {
                            initialSelectedIds: newDeals,
                            onSelect: (dealId) => setLeadQuotes(dealId)
                        }
                    })
                }
            }
        }

    }, [updateLeadResponse])


    const columns = profileState.lead_columns
    const sortedColumns = Object.keys(columns).sort((a, b) => columns[a] - columns[b])

    return (
        <tr className={'LeadItem'}>
            <td
                width={'1%'}
                key='Select'
                className={'select'}
            >
                <Checkbox
                    onChange={(e) => toggleSelected()}
                    checked={selectedLeads.includes(lead.id)}
                />
            </td>
            <td className={'LeadItem-td'} key='Name'>
                <input
                    onFocus={handleOnFocus}
                    onBlur={handleBlur}
                    type="text"
                    onChange={(e) => {
                        setStateWithUpdate({...leadState, name: e.target.value})
                    }}
                    value={leadState.name}
                />
            </td>
            <td className={'LeadItem-td'} key='Phone'>
                <input
                    onFocus={handleOnFocus}
                    onBlur={handleBlur}
                    type="text"
                    onChange={(e) => {
                        setStateWithUpdate({...leadState, phone_number: e.target.value})
                    }}
                    value={leadState.phone_number}
                />
            </td>
            <td className={'LeadItem-td'} key='Email'>
                <input
                    onFocus={(e) => {
                        handleOnFocus(e)
                        handleEmailFocus()
                    }}
                    onBlur={(e) => {
                        handleBlur(e)
                        handleEmailBlur(e)
                    }}
                    type="text"
                    onChange={(e) => {
                        setStateWithUpdate({...leadState, email: e.target.value})
                    }}
                    value={leadState.email}
                />
            </td>
            {
                sortedColumns.map(columnID => {
                    return (
                        <CustomCRMItemRowEntry
                            handleBlur={handleBlur}
                            handleOnFocus={handleOnFocus}
                            columnID={columnID}
                            columns={columns}
                            state={leadState}
                            setStateWithUpdate={setStateWithUpdate}
                        />
                    )
                })
            }

            <td
                className={'LeadItem-td'}
                onClick={() => {
                    openModal({
                        element: CRMListDealsModal,
                        id: "CRMListDealsModal",
                        props: {
                            initialSelectedIds: leadState.deals,
                            onSelect: (dealId) => setLeadQuotes(dealId),
                        }
                    })
                }}
            >
                <div className={'LeadItem-td_quotes'}>
                    {leadState.deals.length} Quote{leadState.deals.length === 1 ? "" : "s"}
                </div>
            </td>

            <td className={'LeadItem-td'}>
                <MoreHorizIcon
                    onClick={handleActionClick}
                    className={'CRM-action-button'}
                />
                <Popover
                    onClick={(e) => e.stopPropagation()}
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleActionClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        horizontal: 'right',
                        vertical: 'top'
                    }}
                >
                    <Typography
                        sx={{ p: 2, fontWeight: 500 }}
                        className={'ListDealCard-menu-item'}
                        onClick={deleteLeadItem}
                    >
                        Delete
                        <DeleteSharpIcon
                            className={classnames(
                                'action-icon', {
                                    // loader: isDeleting
                                }
                            )}
                        />
                    </Typography>
                </Popover>
            </td>
        </tr>
    )
}